<template>
    <div class="step-container">
        <div class="content">
            <p>Si nos queres dejar algún comentario o información adicional sobre tu pedido podes escribirlo a continuación.</p>

            <textarea class="textarea" v-model="text"></textarea>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                text: ''
            }
        },

        watch: {
            text(value) {
                this.$emit('input', value);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "./../../assets/css/checkout.scss";
</style>